import { useEffect } from 'react';
import { useSocketStore } from '../../stores/useSocketStore';
import { useChegadasViagensStore } from "../../stores/useChegadasViagensStore";

export function useEnsureChegadas(codigo) {

    const socket = useSocketStore(state => state.socket);

    useEffect(() => {

        if (!socket) {
            return;
        }

        const key = String(codigo || '').trim();

        if (!key) {
            return;
        }

        const {
            chegadas,
            setChegadas
        } = useChegadasViagensStore.getState();

        if (key in chegadas) {
            return;
        }

        socket.emit(
            'chegadas-viagens:get',
            key,
            response => {

                setChegadas(
                    key,
                    response?.data?.chegadasViagens || []
                );

            }
        );

    }, [socket, codigo]);

}